// extracted by mini-css-extract-plugin
export var animated = "styles-module--animated--678a8";
export var tooltip = "styles-module--tooltip--b113d";